module.exports = __webpack_public_path__ + "img/head-img-smart-construction.15be0a23.png";